import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import { DlaService } from 'src/app/shared/dla.service';

@Component({
  selector: 'app-forum-details',
  templateUrl: './forum-details.component.html',
  styleUrls: ['./forum-details.component.css']
})
export class ForumDetailsComponent implements OnInit, AfterViewInit {

  mainPageTitle = 'Forum';
  forum_id: string;
  forum: any;
  comments: any = [];
  userinfo: any;
  commentForm: FormGroup;
  submitted = false;


  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private dlaService: DlaService
  ) {
    this.commentForm = this.formBuilder.group({
      comment: ['', Validators.required]
    });
  }

  get f() { return this.commentForm.controls; }

  ngAfterViewInit(): void {
    this.submitViewForum();
  }

  ngOnInit(): void {
    this.loadScripts();
    this.userinfo = JSON.parse(localStorage.getItem('dla_student'));
    this.forum_id = this.route.snapshot.paramMap.get('id');
    this.getForumDetails();

  }


  getForumDetails() {
    this.spinner.show();
    this.dlaService.getForumDetails(this.forum_id).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {

          this.forum = data;
          this.comments = this.forum.comments;
          console.log(this.comments);
        } else {
          this.alertService.danger(data.message);
        }
      },
      error => {
        this.spinner.hide();
        this.alertService.danger('An error occurred, Please try again');
      }
    );
  }

  getForumDetailsNoSpinner() {

    this.dlaService.getForumDetails(this.forum_id).subscribe(
      (data: any) => {

        const error: boolean = data.error;
        if (!error) {

          this.forum = data;
          this.comments = this.forum.comments;
          console.log(this.comments);
        } else {

        }
      },
      error => {

      }
    );
  }

  submitViewForum() {

    this.dlaService.submitViewForum(this.forum_id).subscribe(
      (data: any) => {

        const error: boolean = data.error;
        if (!error) {
          this.getForumDetailsNoSpinner();
          console.log(data.message);
        } else {
          console.log(data.message);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  likePost() {
    this.dlaService.submitLikeForum(this.forum_id).subscribe(
      (data: any) => {

        const error: boolean = data.error;
        if (!error) {
          this.getForumDetailsNoSpinner();
          console.log(data.message);
        } else {
          console.log(data.message);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.commentForm.invalid) {
      return;
    }


    this.spinner.show();
    this.dlaService.submitForumComment(this.forum_id, this.userinfo.user_id, this.commentForm.value.comment).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        if (!error) {
          this.alertService.success(data.message);
          this.getForumDetailsNoSpinner();
        } else {
          this.alertService.danger(data.message);
        }
      },
      error => {
        this.spinner.hide();
        this.alertService.danger('An error occurred, Please try again');
      }
    );

  }

  loadScripts() {

    const dynamicScripts = [
      'assets/js/vendor/jquery-1.11.3.min.js',
      'assets/js/bootstrap.min.js',
      'assets/js/wow.min.js',
      'assets/js/jquery-price-slider.js',
      'assets/js/jquery.meanmenu.js',
      'assets/js/owl.carousel.min.js',
      'assets/js/jquery.sticky.js',
      'assets/js/jquery.scrollUp.min.js',
      'assets/js/scrollbar/jquery.mCustomScrollbar.concat.min.js',
      'assets/js/scrollbar/mCustomScrollbar-active.js',
      'assets/js/metisMenu/metisMenu.min.js',
      'assets/js/metisMenu/metisMenu-active.js',
      // 'assets/js/morrisjs/raphael-min.js',
      // 'assets/js/morrisjs/morris.js',
      // 'assets/js/morrisjs/morris-active.js',
      'assets/js/tab.js',
      'assets/js/sparkline/jquery.sparkline.min.js',
      'assets/js/sparkline/jquery.charts-sparkline.js',
      'assets/js/calendar/moment.min.js',
      'assets/js/calendar/fullcalendar.min.js',
      'assets/js/calendar/fullcalendar-active.js',
      'assets/js/plugins.js',
      'assets/js/main.js'
    ];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }
}
